var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61963 4.19789L8.95038 2.86716C9.22495 2.59233 9.55097 2.3743 9.90983 2.22551C10.2687 2.07672 10.6533 2.00009 11.0418 2C11.4303 1.99991 11.815 2.07636 12.1739 2.22498C12.5329 2.3736 12.859 2.59149 13.1337 2.86618C13.4084 3.14088 13.6263 3.46701 13.7749 3.82593C13.9235 4.18486 14 4.56955 13.9999 4.95802C13.9998 5.3465 13.9232 5.73116 13.7744 6.09001C13.6256 6.44887 13.4075 6.77489 13.1327 7.04946L11.2317 8.95051C10.957 9.22513 10.631 9.44296 10.2722 9.59158C9.91341 9.7402 9.52885 9.81669 9.14048 9.81669C8.75212 9.81669 8.36755 9.7402 8.00875 9.59158C7.64995 9.44296 7.32393 9.22513 7.04932 8.95051",
    stroke: "#1D253C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38023 11.8019L7.04949 13.1326C6.77492 13.4075 6.4489 13.6255 6.09004 13.7743C5.73118 13.9231 5.34652 13.9997 4.95804 13.9998C4.56956 13.9999 4.18487 13.9234 3.82594 13.7748C3.46701 13.6262 3.14089 13.4083 2.86619 13.1336C2.59149 12.8589 2.37361 12.5328 2.22498 12.1739C2.07636 11.8149 1.99991 11.4303 2 11.0418C2.00009 10.6533 2.07672 10.2686 2.22551 9.90979C2.3743 9.55093 2.59234 9.22491 2.86716 8.95034L4.76822 7.04929C5.04284 6.77468 5.36885 6.55684 5.72766 6.40822C6.08646 6.2596 6.47102 6.18311 6.85939 6.18311C7.24775 6.18311 7.63231 6.2596 7.99112 6.40822C8.34992 6.55684 8.67594 6.77468 8.95055 7.04929",
    stroke: "#1D253C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.4359187477ae59e2b7bef47882af1b2e.svg";
export { ForwardRef as ReactComponent };